import {Form, Select} from "antd";
import "./Filters.css"
import {useEffect, useState} from "react";
import {useGetInsuranceProvidersQuery} from "../../../../store/states/InsuranceProvidersState";
import {InsuranceProviderEclaim} from "../../../../models/InsuranceProvider";
import {InsuranceProviderAuthorizationHttpService} from "../../../../services/Http/InsuranceProviderAuthorizationHttpService";
import {InsuranceProviderAuthorizationOperationType} from "../../../../models/InsuranceProviderAuthorization";

export interface FilterConvectionProps{
    onChange?:(value:number)=>void;
}
export function FilterConvection (props:FilterConvectionProps){
    const {data: insuranceProviders, error, isLoading} = useGetInsuranceProvidersQuery([], { refetchOnMountOrArgChange: true });
    const [directManagementIds, setDirectManagementIds] = useState<number[]>([]);

    useEffect(() => {
        InsuranceProviderAuthorizationHttpService.getIdsByOperationType(InsuranceProviderAuthorizationOperationType.DIRECT_MANAGEMENT)
            .then(res => setDirectManagementIds(res.data))
            .catch(() => setDirectManagementIds([]));
    }, []);

    const handleChange = (value: string) => {
        if(props?.onChange) {
            props?.onChange(Number(value))
        }
    };

    function getOptions():any[]|undefined{
        const ips = insuranceProviders || [];

        const gestioneDiretta = ips.filter((ip:InsuranceProviderEclaim) => {
            return directManagementIds.includes(ip.id);
        }).sort((a:InsuranceProviderEclaim,b:InsuranceProviderEclaim) => {
            return a.description.localeCompare(b.description)
        });

        const gestioneIndiretta = ips.filter((ip:InsuranceProviderEclaim) => {
            return !directManagementIds.includes(ip.id);
        }).sort((a:InsuranceProviderEclaim,b:InsuranceProviderEclaim) => {
            return a.description.localeCompare(b.description)
        })

        return [...gestioneDiretta, ...gestioneIndiretta].map((element:InsuranceProviderEclaim)=>{
            return { label:element.description, value:element.id }
        });
    }
    return <>
        <Form.Item name={"insuranceProviderId"}>
            <Select
                placeholder="Convenzione"
                className={"filter"}
                options={getOptions()}
                onChange={handleChange}
                showSearch
                optionFilterProp="label"
                allowClear={true}
            />
        </Form.Item>

    </>
}
